export const C = {
  bg: '#FBF8F5',
  text: '#0F2B3C',
  textMid: '#64748B',
  textLight: '#64748B',
  primary: '#E8614D',
  primaryLight: '#FDEDE9',
  secondary: '#0D9488',
  secondaryLight: '#E6FFFB',
  accent: '#14B8A6',
  accentLight: '#E8FFFB',
  success: '#16A34A',
  successLight: '#ECFDF3',
  danger: '#E8614D',
  dangerLight: '#FDEDE9',
  purple: '#0F766E',
  purpleLight: '#E6FFFB',
  accent2: '#14B8A6'
};
